import { render, staticRenderFns } from "./ReadChat.vue?vue&type=template&id=4854f69c&scoped=true&"
import script from "./ReadChat.vue?vue&type=script&lang=js&"
export * from "./ReadChat.vue?vue&type=script&lang=js&"
import style0 from "./ReadChat.vue?vue&type=style&index=0&id=4854f69c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4854f69c",
  null
  
)

export default component.exports